import { render } from "./OrganisationSidebar.vue?vue&type=template&id=d29135ac"
import script from "./OrganisationSidebar.vue?vue&type=script&lang=js"
export * from "./OrganisationSidebar.vue?vue&type=script&lang=js"

import "./OrganisationSidebar.vue?vue&type=style&index=0&id=d29135ac&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__